import api, {instance} from '../../utils/api';
import {DocumentType, FileEntity, FileTag, FileTagEntity, UsedFileTag} from '@pages/FilesPage';
import {AxiosProgressEvent, AxiosResponse} from 'axios';
import {ReportData, ReportGenerationInfo} from 'components/ReportModal/types';

export class FilesService {
    private static instance: FilesService;

    public static getInstance() {
        if (!FilesService.instance) {
            FilesService.instance = new FilesService();
        }

        return FilesService.instance;
    }

    private constructor() {}

    public async createFile(
        data: FormData,
        params: Record<string, string | number | undefined>,
        onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
        signal?: AbortSignal,
    ): Promise<void> {
        await instance({
            method: 'POST',
            url: `/files/uploadWithGroupId`,
            data,
            params,
            onUploadProgress,
            signal,
            withoutGlobalLoader: true,
        });
    }

    public async deleteFile(id: string): Promise<void> {
        await api.delete(`/files/${id}`);
    }

    public async queryToRunReportProcessing(
        type: string,
        queryParams: Record<string, any>,
        body: Record<string, any>,
    ): Promise<ReportGenerationInfo> {
        const response = await instance.post(`/export/${type}`, body, {params: queryParams});
        return response.data;
    }

    public async getReportStatus(
        reportId: string,
        withoutGlobalLoader = false,
    ): Promise<ReportData> {
        return await api.get(`/export/${reportId}`, undefined, {withoutGlobalLoader});
    }

    public downloadFileFromTable(link: string): Promise<AxiosResponse<string>> {
        return instance.get(link, {
            responseType: 'blob',
            errorMessage: 'Не удалось скачать шаблон',
        });
    }

    public downloadFile(id: string) {
        return instance({
            method: 'GET',
            url: `/export/download?id=${id}`,
            responseType: 'blob',
            withoutGlobalLoader: true,
        });
    }

    public downloadFileByUrl(url: string) {
        return instance({
            method: 'GET',
            url: url,
            responseType: 'blob',
        });
    }

    public async uploadStowageRegistersTemplate(
        url: string,
        data: FormData,
        params: Record<string, string | number | undefined>,
    ): Promise<void> {
        await instance({
            method: 'POST',
            url: `/${url}/import`,
            data,
            params,
        });
    }
}

export const getFileTags = (wellId: string): Promise<FileTag[]> => {
    return api.get(`/files/tags`, {wellId});
};

export const addFileTag = (title: string, wellId: string): Promise<FileTagEntity> => {
    return api.post(`/files/tags`, {title, wellId});
};

export const deleteFileTag = (tagId: string): Promise<void> => {
    return api.delete(`/files/tags/${tagId}`);
};

export const isUsedFileTag = (tagId: string): Promise<UsedFileTag> => {
    return api.get(`/files/tags/${tagId}/isUsed`);
};

export const updateFile = (
    id: string,
    documentDate: string,
    tagIds: string[],
    type: DocumentType,
): Promise<FileEntity> => {
    return api.put(`/files/${id}`, {documentDate, tagIds, type});
};
